import React, { Component } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';
import 'moment-timezone';

import { connect } from 'react-redux';

import { THEME } from '../../configs/global';

import iconBackArrowNX from '../../assets/images/ic-back-arrow.svg';
import iconBackArrowBusEireann from '../../assets/images/bus-eireann/back-arrow-header.svg';
import iconBackArrowDublinExpess from '../../assets/images/dublin-express/back-arrow-header.svg';
import iconBackArrowHinkley from '../../assets/images/hinkley/back-arrow-header.svg';
import iconBackArrowMegabus from '../../assets/images/megabus/back-arrow-header.svg';
import iconBackArrowNXbus from '../../assets/images/nxbus/back-arrow-header.svg';
import iconBackArrowWCCE from '../../assets/images/wcce/back-arrow-header.svg';
import iconBackArrowCitylink from '../../assets/images/citylink/back-arrow-header.svg';
import iconBackArrowRegsCoaches from '../../assets/images/regscoaches/back-arrow-header.svg';
import iconBackArrowSutton from '../../assets/images/suttonparkbus/back-arrow-header.svg';

const BookTicketURL = THEME.BOOKING_URL;
const ServiceURL =
  'https://book.nationalexpress.com/coach/#/campaign?journeyType=single&departArrive=DepartAfter&partnerId=uTrack&campaignId=default&returnDate=&departArriveReturn=DepartAfter&returnTime=';

const embed = window.location.hostname.includes('-embed') || window.location.hostname.includes('-webview');

const getIconBackArrowNX = (name) => {
  switch (name) {
    case 'NX':
      return iconBackArrowNX;
    case 'Dublin-Express':
      return iconBackArrowDublinExpess;
    case 'Hinkley':
      return iconBackArrowHinkley;
    case 'Megabus':
      return iconBackArrowMegabus;
    case 'NX-Bus':
      return iconBackArrowNXbus;
    case 'WCCE':
        return iconBackArrowWCCE; 
    case 'Citylink':
        return iconBackArrowCitylink;
    case 'Regscoaches':
        return iconBackArrowRegsCoaches;
    case 'Suttonparkbus':
        return iconBackArrowSutton;
  
    default:
      return iconBackArrowBusEireann;
  }
};

class TopBar extends Component {
  static propTypes = {
    title: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
  };

  render() {
    const { bookTicketData, title, onClick, className } = this.props;

    const today = moment(bookTicketData.time, 'YYYY-MM-DD HH:mm:ss Z').tz(
      'Europe/London'
    );
    const departureDate = today.format('DD/MM/YYYY');
    const departureTime = today.format('HH:mm');

    return (
      <div className={`navlink ${className}`}>
        <div onClick={onClick} className="back-arrow">
          <img src={getIconBackArrowNX(THEME.NAME)} alt="back arrow" />
          <p>{title}</p>
        </div>
        {!embed && THEME.NAME !== 'NX' && THEME.BOOKING_URL && THEME.BOOKING_URL !== '#' ? (
          <a
            href={BookTicketURL}
            className="mobile-book"
            target="_blank"
            rel="noopener noreferrer"
          >
            Book tickets
          </a>
        ) : (!embed && THEME.NAME === 'NX' &&
          <a
            href={
              bookTicketData && bookTicketData.time
                ? `${ServiceURL}&departureDate=${departureDate}&outboundTime=${departureTime}&departureStopId=${
                    bookTicketData.request[0].bookingId
                  }&destinationStopId=${bookTicketData.request[1].bookingId}&${
                    bookTicketData.services[0].operatorId === 'OU'
                      ? 'ouiAdults=1'
                      : 'adults=1'
                  }`
                : BookTicketURL
            }
            className="mobile-book"
            target="_blank"
            rel="noopener noreferrer"
          >
            Book tickets
          </a>
        )}
      </div>
    );
  }
}

TopBar.defaultProps = {
  className: '',
};

const mapStateToProps = (state) => ({
  bookTicketData: state.services,
});

export default connect(mapStateToProps, {})(TopBar);



// WEBPACK FOOTER //
// ./src/containers/service-list/TopBar.js